import { FiAlertTriangle, FiInfo } from "react-icons/fi";
import { BaseIconBoxProps, IconBox } from "./IconBox";
import { cn } from "utils/helpers";

export const WarningBox = ({ children, className }: BaseIconBoxProps) => {
	return (
		<IconBox borderColor='border-orange-200' icon={FiAlertTriangle} iconFill="fill-yellow-300" iconStroke="stroke-black" className={cn("bg-yellow-100", className)}>
			{children}
		</IconBox>
	);
};
